var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKakaoTalk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.1936C7.37363 4.1936 3.62329 7.15064 3.62329 10.7983C3.62329 13.1567 5.19125 15.2258 7.54976 16.3944C7.4215 16.8369 6.72522 19.2412 6.69746 19.4301C6.69746 19.4301 6.68083 19.572 6.77265 19.6262C6.86462 19.6803 6.97264 19.6383 6.97264 19.6383C7.23626 19.6015 10.0287 17.6399 10.5121 17.2993C10.995 17.3677 11.4923 17.4033 12 17.4033C16.6264 17.4033 20.3767 14.4463 20.3767 10.7986C20.3767 7.15078 16.6264 4.1936 12 4.1936Z",
    fill: "#232429"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaoTalk);
export default __webpack_public_path__ + "static/media/kakao-talk.088018e63e2254dc08f2ae6785c27093.svg";
export { ForwardRef as ReactComponent };